export enum ElectricalDeviceType {
  LOAD = "LOAD",
  CONTROLLER = "CONTROLLER",
}

export enum LoadConnectionType {
  EXPLICIT_LOAD_INDEX = "EXPLICIT_LOAD_INDEX",
  NEAREST_LOAD = "NEAREST_LOAD",
  NEAREST_LOAD_ARRAY_TERMINUS = "NEAREST_LOAD_ARRAY_TERMINUS",
}
